module.exports = __webpack_public_path__ + "img/reply-fill.f0988b44.svg";